"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatFoundationHolding = exports.formatSearchQuery = exports.formatGovernanceAssetsById = exports.formatTransactionHistory = exports.formatGovernanceBalanceById = exports.formatMultiDatasCard = exports.formatGovernanceMetrics = exports.formatSupplyMetrics = exports.formatLedgerTimeseriesById = exports.formatTransactionDetailsByTxhash = exports.formatTransactionHistoryById = exports.formatOrigynForecast = exports.formatPrincipalStakesList = exports.formatStakesList = exports.formatBalanceWithGovernanceList = exports.formatGovernanceList = exports.formatBalanceListByPage = exports.formatTokenDistribution = exports.formatBurnedSupplyTimeseries = exports.formatSupplyTimeseries = exports.formatNatAmount = exports.formatFloatAmount = exports.formatAmount = exports.moveDecimal = exports.truncateFraction = exports.nFormatter = exports.toLocaleNumber = exports.capitalizeFirstLetter = exports.formatAddress = exports.shortenNumber = exports.formatLabel = exports.b = exports.m = exports.locale = void 0;
const AccountIdBox_1 = __importDefault(require("@/components/layout/AccountIdBox"));
const material_1 = require("@mui/material");
const React = __importStar(require("react"));
const Timestamp_1 = __importDefault(require("@/components/interactions/Timestamp"));
const Amount_1 = __importStar(require("@/components/layout/Amount"));
const CustomToolTip_1 = __importDefault(require("@/components/interactions/CustomToolTip"));
exports.locale = 'en-GB';
exports.m = 1000000;
exports.b = 1000000000;
const formatLabel = (str) => {
    return str.replace(/([A-Z]+)/g, ' $1');
};
exports.formatLabel = formatLabel;
const shortenNumber = n => {
    if (n < 1e3)
        return n;
    if (n >= 1e3 && n < 1e6)
        return +(n / 1e3).toFixed(2) + "K";
    if (n >= 1e6 && n < 1e9)
        return +(n / 1e6).toFixed(2) + "M";
    if (n >= 1e9 && n < 1e12)
        return +(n / 1e9).toFixed(2) + "B";
    if (n >= 1e12)
        return +(n / 1e12).toFixed(2) + "T";
};
exports.shortenNumber = shortenNumber;
const formatAddress = (str) => {
    return str?.slice(0, 22) + '...';
};
exports.formatAddress = formatAddress;
const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
exports.capitalizeFirstLetter = capitalizeFirstLetter;
const toLocaleNumber = (n) => {
    return (n?.toLocaleString(undefined, {
        maximumFractionDigits: 2,
    }));
};
exports.toLocaleNumber = toLocaleNumber;
const nFormatter = (num, digits) => {
    const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup.slice().reverse().find(function (item) {
        return num >= item.value;
    });
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
};
exports.nFormatter = nFormatter;
const truncateFraction = (num) => {
    // examples:
    // abc returns ''
    // .50 returns 0.50
    // 00000 returns 0
    // 000.123 returns 0
    // 0.123 returns 0.123
    // 0.00 returns 0.00
    // 12345.1234567890 returns 12345.12345678
    if (num.indexOf('.') === 0) {
        num = `0${num}`;
    }
    const m = num.match(/(?:0|(?:[1-9](?:\d+)?))(?:\.(?:\d{1,8})?)?/);
    return m?.[0] ?? '';
};
exports.truncateFraction = truncateFraction;
const moveDecimal = (num) => {
    // examples:
    // 0.009 returns 900000n
    // 12345.678 returns 1234567800000n
    // 12.000678 returns 1200067800n
    // 1.23456789 returns 12345678n
    let result = '';
    const validNumber = (0, exports.truncateFraction)(num);
    const parts = validNumber.split('.');
    const wholeNumber = parts[0] === '0' ? '' : parts[0];
    if (parts?.[1]) {
        result = `${wholeNumber}${parts[1]}`.padEnd(wholeNumber.length + 8, '0');
    }
    else {
        result = wholeNumber.padEnd(wholeNumber.length + 8, '0');
    }
    // remove the leading zeros
    const match = result.match(/(?:0+)?(\d+)/);
    if (match && match.length > 0) {
        return BigInt(match[1]).valueOf();
    }
    return 0n;
};
exports.moveDecimal = moveDecimal;
const formatAmount = (n) => {
    if (typeof n !== 'number') {
        return n;
    }
    else
        return Number(n.toFixed()).toLocaleString(exports.locale);
};
exports.formatAmount = formatAmount;
const formatFloatAmount = (n, symbol = ',') => {
    const s = n.toString().split('.');
    return (s[0].replace(/\B(?=(\d{3})+(?!\d))/g, symbol) || "0") + '.' + (s[1] || "0");
    ;
};
exports.formatFloatAmount = formatFloatAmount;
const formatNatAmount = (n, symbol = ',') => {
    const s = n.toString();
    if (s.length >= 8) {
        const f = s.substring(s.length - 8, s.length - 6);
        const m = s.substring(0, s.length - 8);
        return (m.replace(/\B(?=(\d{3})+(?!\d))/g, symbol) || "0") + '.' + f;
    }
    return "0";
};
exports.formatNatAmount = formatNatAmount;
const formatSupplyTimeseries = (data) => {
    const tokenSupplyFeed = [];
    const payload = [];
    data.forEach((object) => {
        const ot = {
            date: new Date(object.date).toLocaleDateString(exports.locale),
            circulatingSupply: object.circulatingSupply,
            tokensInGovernance: object.tokensInGovernance.total,
            origynFoundation: object.totalOrigynFoundation,
        };
        const pt = {
            totalSupply: object.totalSupply,
            date: new Date(object.date).toLocaleDateString(exports.locale),
            circulatingSupply: object.circulatingSupply,
            tokensInGovernance: object.tokensInGovernance.total,
            origynFoundation: object.totalOrigynFoundation,
        };
        tokenSupplyFeed.push(ot);
        payload.push(pt);
    });
    return {
        tokenSupplyFeed,
        payload,
    };
};
exports.formatSupplyTimeseries = formatSupplyTimeseries;
const formatBurnedSupplyTimeseries = (data) => {
    const formatedData = [];
    data.map((e, i) => {
        formatedData.push({
            date: e.date,
            burnedFees: e.burnedFees,
            burnedTokens: e.burnedTokens,
        });
    });
    return formatedData;
};
exports.formatBurnedSupplyTimeseries = formatBurnedSupplyTimeseries;
const formatTokenDistribution = (data) => {
    const formatedData = [];
    data.map((e, i) => {
        if (e.desc !== 'Total') {
            formatedData.push({
                ...e,
            });
        }
    });
    return formatedData;
};
exports.formatTokenDistribution = formatTokenDistribution;
const formatBalanceListByPage = (data) => {
    const formatedData = [];
    const governanceIds = {
        "b7caca859346f4350b7614f754f24c878890df143a24e1ac4aa0416f3fdfa54c": "Governance Canister",
        "1615b0e183e5cfa4e90ff8863c037e4236d94b2d90f7060a49f0bf4c8935ec3d": "Foundation Ledger",
        "e1cef7154b02b94e7c0097e312212d61bc5ca6035ba8ae298d2ab6392458ffc0": "Vesting Canister",
        "1dd13cffc69191d68f0cef5e5b7b7cbcd37e77bb2b33d591cfc9e23ade6c2161": "ORIGYN Reward Account (ORA)",
        "8f5a9ad92af474a18a70242ad0bf6d90c17053cbfe49459257a863da50bb4abf": "BFS",
        "a2c3b912c3fb2c3c57357f5f2f04c8ca829a8653c8e1499a534dbea9f5669f3a": "ECOSYSTEM FUND",
        "866d1d3e628ae7f0db83bcb4f3eefa855179c44591739a8d4f5c35c8ba9593e1": "Founder 1",
        "b9b2afaa00c237fdb15195dbf7339788715b1686a593baca442b2b21584cb29a": "Founder 2",
        "3f6150769458d90335e49d6c7defbeafce138cc5fd7e4f2bdee91185534829cd": "Founder 3",
        "4da90ebcd6fb3f4c74c8456e2313727cf8d5ee9a510649125cd69ce09bbbaad9": "Biosphere DAO - Cecile",
        "bffc186b730f053668b98ede1c3b2ee572f33a0ad8be711359058ea725aa6e11": "Art and Culture DAO",
        "f6fb18142367e4330c32fac2dd7f2791c0a66e5b3a113ac46e0c527934f06be2": "Children DAO"
    };
    data.balances.map((e, i) => {
        formatedData.push({
            "Canister Account Id": [React.createElement(AccountIdBox_1.default, { path: "/account", id: e.accountId, tooltip: governanceIds[e.accountId], label: e.accountId })],
            balance: [
                React.createElement(Amount_1.default, { noSign: true, size: Amount_1.AmountSize.Small, amount: (0, exports.formatAmount)(e.balance), horizontal: true }),
            ],
        });
    });
    return {
        totalNumber: data.totalNumberOfAccounts,
        data: formatedData,
        limit: data.limit,
        page: data.page,
    };
};
exports.formatBalanceListByPage = formatBalanceListByPage;
const formatGovernanceList = (data) => {
    const formatedData = [];
    const founders = {
        "ycolt-awguw-2a2d3-xyau5-g5s3c-vmah6-qjscz-cdskd-migje-iq7uo-cae": "Founder 1",
        "tusfe-gykaq-cyqmf-ksban-w6gyx-bwelx-gxh54-47xjk-yn2en-gfnnr-bae": "Founder 2",
        "6t4nh-5jx5p-syvey-6xhvm-k5yqa-ahlbp-acbtn-v4esd-azuuc-p3vxl-sae": "Founder 3",
    };
    data.balances.map((e, i) => {
        formatedData.push({
            address: [
                React.createElement(material_1.Box, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                    } },
                    React.createElement(AccountIdBox_1.default, { id: e.address, label: e.address.length > 25 ? e.address : e.title || e.address, path: '/governance' }),
                    React.createElement("div", null, founders[e.address] && React.createElement(CustomToolTip_1.default, { description: founders[e.address] }))),
            ],
            locked: [
                React.createElement(Amount_1.default, { noSign: true, size: Amount_1.AmountSize.Small, horizontal: true, amount: (0, exports.formatAmount)(e.locked.total) }),
            ],
            unlocked: [
                React.createElement(Amount_1.default, { noSign: true, size: Amount_1.AmountSize.Small, horizontal: true, amount: (0, exports.formatAmount)(e.unlocked.total) }),
            ],
            total: [React.createElement(Amount_1.default, { noSign: true, size: Amount_1.AmountSize.Small, horizontal: true, amount: (0, exports.formatAmount)(e.total) })],
            dissolving: [React.createElement(Amount_1.default, { noSign: true, size: Amount_1.AmountSize.Small, horizontal: true, amount: (0, exports.formatAmount)(e.other.dissolving.staked) })],
            "Locked For Less Then Year": [React.createElement(Amount_1.default, { noSign: true, size: Amount_1.AmountSize.Small, horizontal: true, amount: (0, exports.formatAmount)(e.other.lessThanOneYear.staked) })],
        });
    });
    return {
        totalNumber: data.totalNumberOfAccounts,
        data: formatedData,
        limit: data.limit,
        page: data.page,
    };
};
exports.formatGovernanceList = formatGovernanceList;
const formatBalanceWithGovernanceList = (data, totalSupply) => {
    const formatedData = [];
    const founders = {
        "b7caca859346f4350b7614f754f24c878890df143a24e1ac4aa0416f3fdfa54c": "Governance Canister",
        "1615b0e183e5cfa4e90ff8863c037e4236d94b2d90f7060a49f0bf4c8935ec3d": "Foundation Ledger",
        "e1cef7154b02b94e7c0097e312212d61bc5ca6035ba8ae298d2ab6392458ffc0": "Vesting Canister",
        "1dd13cffc69191d68f0cef5e5b7b7cbcd37e77bb2b33d591cfc9e23ade6c2161": "ORIGYN Reward Account (ORA)",
        "8f5a9ad92af474a18a70242ad0bf6d90c17053cbfe49459257a863da50bb4abf": "BFS",
        "a2c3b912c3fb2c3c57357f5f2f04c8ca829a8653c8e1499a534dbea9f5669f3a": "ECOSYSTEM FUND",
        "866d1d3e628ae7f0db83bcb4f3eefa855179c44591739a8d4f5c35c8ba9593e1": "Founder 2",
        "b9b2afaa00c237fdb15195dbf7339788715b1686a593baca442b2b21584cb29a": "Founder 1",
        "3f6150769458d90335e49d6c7defbeafce138cc5fd7e4f2bdee91185534829cd": "Founder 3",
    };
    data.balances.map((e, i) => {
        formatedData.push({
            address: [
                e.principalId ? (React.createElement(material_1.Box, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                    } },
                    React.createElement(AccountIdBox_1.default, { id: e.principalId, label: e.principalId, path: '/governance' }),
                    React.createElement("div", null, founders[e.account] && React.createElement(CustomToolTip_1.default, { description: founders[e.account] })))) : (React.createElement(material_1.Box, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                    } },
                    React.createElement(AccountIdBox_1.default, { id: e.account, label: e.account.length > 25 ? e.account : e.title || e.account, path: '/account' }),
                    React.createElement("div", null, founders[e.account] && React.createElement(CustomToolTip_1.default, { description: founders[e.account] })))),
            ],
            total: [React.createElement(Amount_1.default, { noSign: true, size: Amount_1.AmountSize.Small, horizontal: true, amount: (0, exports.formatAmount)(e.balance.total) })],
            "Governance Balance": [
                React.createElement(Amount_1.default, { noSign: true, size: Amount_1.AmountSize.Small, horizontal: true, amount: e.balance.totalInGovernance === 0 ? "-" : (0, exports.formatAmount)(e.balance.totalInGovernance) }),
            ],
            "Ledger Balance": [
                React.createElement(Amount_1.default, { noSign: true, size: Amount_1.AmountSize.Small, horizontal: true, amount: e.balance.ledgerBalance === 0 ? "-" : (0, exports.formatAmount)(e.balance.ledgerBalance) }),
            ],
            "Weight in total supply": [
                React.createElement(Amount_1.default, { noSign: true, size: Amount_1.AmountSize.Small, horizontal: true, amount: `${(e.balance.total / totalSupply * 100).toFixed(2)} %` }),
            ]
        });
    });
    return {
        totalNumber: data.totalNumberOfAccounts,
        data: formatedData,
        limit: data.limit,
        page: data.page,
    };
};
exports.formatBalanceWithGovernanceList = formatBalanceWithGovernanceList;
const formatStakesList = (data) => {
    const formatedData = [];
    data.data.map((e, i) => {
        formatedData.push({
            principal: [
                React.createElement(material_1.Box, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                    } },
                    React.createElement(AccountIdBox_1.default, { id: e.address, label: e.principal, isNotLink: true, path: '/governance' })),
            ],
            amount: [React.createElement(Amount_1.default, { size: Amount_1.AmountSize.Small, horizontal: true, amount: (0, exports.formatAmount)(e.quantity) })],
        });
    });
    return {
        totalNumber: data.total,
        data: formatedData,
        limit: data.limit,
        page: data.page,
    };
};
exports.formatStakesList = formatStakesList;
const formatPrincipalStakesList = (data) => {
    const formatedData = [];
    data.map((e, i) => {
        formatedData.push({
            amount: [React.createElement(Amount_1.default, { size: Amount_1.AmountSize.Small, horizontal: true, amount: (0, exports.formatAmount)(e.quantity) })],
            endDate: [(new Date(e.release)).toLocaleDateString()],
            rewards: [React.createElement(Amount_1.default, { size: Amount_1.AmountSize.Small, horizontal: true, amount: (0, exports.formatAmount)(e.rewards) })],
        });
    });
    return {
        totalNumber: data.length,
        data: formatedData,
        limit: data.length,
        page: 0,
    };
};
exports.formatPrincipalStakesList = formatPrincipalStakesList;
const formatOrigynForecast = (data) => {
    const payload = [];
    data.map((e, i) => {
        const inputDate = e.date;
        const dateParts = inputDate.split('-');
        const outputDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
        data[i].date = outputDate;
        payload.push({
            date: outputDate,
            total: e.staked + e.vested,
            staked: e.staked,
            vested: e.vested,
        });
    });
    return {
        data: data,
        payload: payload,
    };
};
exports.formatOrigynForecast = formatOrigynForecast;
const formatTransactionHistoryById = (data, page, limit) => {
    const formatedData = [];
    data.transactions.map((e, i) => {
        formatedData.push({
            txHash: [React.createElement(AccountIdBox_1.default, { id: e.block_identifier.hash, path: "/hash", label: e.block_identifier.hash })],
            Date: [React.createElement(Timestamp_1.default, { timestamp: Math.floor(e.transaction.metadata.timestamp / 1000000) })],
            from: [e?.transaction?.operations[0]?.type === "MINT" ? React.createElement("div", null) : React.createElement(AccountIdBox_1.default, { label: e.transaction.operations[0]?.account?.address, id: e.transaction.operations[0]?.account?.address, path: "/account" })],
            to: [e?.transaction?.operations[0]?.type === "MINT" ? React.createElement(AccountIdBox_1.default, { label: e.transaction.operations[0]?.account?.address, id: e.transaction.operations[0]?.account?.address, path: "/account" }) : React.createElement(AccountIdBox_1.default, { label: e.transaction.operations[1]?.account?.address, id: e.transaction.operations[1]?.account?.address, path: "/account" })],
            amount: [React.createElement(Amount_1.default, { amount: (0, exports.formatNatAmount)(BigInt(Math.abs(e.transaction.operations[0].amount.value))), size: Amount_1.AmountSize.Small })],
        });
    });
    const r = {
        totalNumber: data.total_count,
        page: page,
        limit: limit,
        data: formatedData,
    };
    return r;
};
exports.formatTransactionHistoryById = formatTransactionHistoryById;
const formatTransactionDetailsByTxhash = (data) => {
    console.log("AMOUNT", data.amount);
    const transaction = {
        type: data.type,
        hash: [
            React.createElement(AccountIdBox_1.default, { path: "", label: data.hash, id: data.hash, isNotLink: true, maxWidth: 600 }),
        ],
        status: data.status,
        date: [React.createElement(Timestamp_1.default, { timestamp: data.timestamp })],
        from: [React.createElement(AccountIdBox_1.default, { label: data.from, id: data.from, maxWidth: 600, path: "/account" })],
        to: [React.createElement(AccountIdBox_1.default, { label: data.to, id: data.to, path: "/account", maxWidth: 600 })],
        amount: React.createElement(Amount_1.default, { size: Amount_1.AmountSize.Small, amount: data?.amount || 0 }),
        fee: React.createElement(Amount_1.default, { size: Amount_1.AmountSize.Small, amount: data.fee ? data.fee : 0 }),
        memo: data.memo,
        block: data.block,
    };
    return transaction;
};
exports.formatTransactionDetailsByTxhash = formatTransactionDetailsByTxhash;
const formatLedgerTimeseriesById = (data) => {
    const txIn = [];
    const txOut = [];
    const balance = [];
    const maxBalance = [];
    data?.history.map((e, i) => {
        txIn.push({ txIn: e?.txIn, date: new Date(e?.date).toLocaleDateString(exports.locale) });
        balance.push({ balance: e?.balance, date: new Date(e?.date).toLocaleDateString(exports.locale) });
        maxBalance.push({ balance: e?.maxBalance, date: new Date(e?.date).toLocaleDateString(exports.locale) });
        txOut.push({ txOut: e?.txOut, date: new Date(e?.date).toLocaleDateString(exports.locale) });
    });
    return {
        maxBalance,
        balance,
        txOut,
        txIn,
        initial: data.initial,
    };
};
exports.formatLedgerTimeseriesById = formatLedgerTimeseriesById;
const formatSupplyMetrics = (data) => {
    data.map((e, i) => {
        e.value = (0, exports.formatAmount)(e.value);
        e.children?.map((e, i) => {
            e.value = (0, exports.formatAmount)(e.value);
            e.children?.map((e, i) => {
                e.value = (0, exports.formatAmount)(e.value);
            });
        });
    });
    return data;
};
exports.formatSupplyMetrics = formatSupplyMetrics;
const formatGovernanceMetrics = (data) => {
    return data;
};
exports.formatGovernanceMetrics = formatGovernanceMetrics;
const formatMultiDatasCard = (data) => {
    delete data.children[4].value;
    return data;
};
exports.formatMultiDatasCard = formatMultiDatasCard;
const formatGovernanceBalanceById = (data) => {
    return data;
};
exports.formatGovernanceBalanceById = formatGovernanceBalanceById;
const formatTransactionHistory = (data) => {
    const formatedData = [];
    data.data.map((e, i) => {
        formatedData.push({
            txHash: [React.createElement(AccountIdBox_1.default, { path: "/hash", id: e.txHash, label: e.txHash })],
            date: [React.createElement(Timestamp_1.default, { timestamp: e.timestamp })],
            from: [React.createElement(AccountIdBox_1.default, { label: e.from, id: e.from, path: "/account" })],
            to: [React.createElement(AccountIdBox_1.default, { label: e.to, id: e.to, path: "/account" })],
            amount: [React.createElement(Amount_1.default, { size: Amount_1.AmountSize.Small, amount: (0, exports.formatAmount)(e.amount) })],
            fee: [React.createElement(Amount_1.default, { size: Amount_1.AmountSize.Small, amount: 0.002 })],
        });
    });
    const r = {
        totalNumber: data.total,
        page: data.page,
        limit: data.limit,
        data: formatedData,
    };
    return r;
};
exports.formatTransactionHistory = formatTransactionHistory;
const formatGovernanceAssetsById = (data) => {
    data.vesting.map((e) => {
        e.date = new Date(e.release).toLocaleDateString(exports.locale);
        delete e.release;
        delete e.dissolving;
    });
    data.staking.map((e) => {
        e.date = new Date(e.release).toLocaleDateString(exports.locale);
        delete e.release;
        delete e.dissolving;
    });
    data.unclaimed.map((e) => {
        e.date = new Date(e.release).toLocaleDateString(exports.locale);
        delete e.release;
        delete e.dissolving;
    });
    return data;
};
exports.formatGovernanceAssetsById = formatGovernanceAssetsById;
const formatSearchQuery = (data) => {
    return data;
};
exports.formatSearchQuery = formatSearchQuery;
const formatFoundationHolding = (data) => {
    let formatedData = {};
    const urls = {
        'ORIGYN Foundation wallet': '/account/1615b0e183e5cfa4e90ff8863c037e4236d94b2d90f7060a49f0bf4c8935ec3d',
        'ORIGYN Foundation': '/governance/b3j22-o6yuq-jdcbo-kk7js-jm24t-q6hkj-hf5fd-bhizo-2erxi-6gk5s-qae',
        'ORIGYN Foundation Voting': '/governance/a4ksl-zqaaa-aaaaj-aadna-cai',
    };
    const children = [];
    data.children.map((e) => {
        children.push({
            ...e,
            url: urls[e.title],
        });
    });
    return {
        name: 'Total',
        value: (0, exports.formatAmount)(data.value),
        children: [...children],
    };
};
exports.formatFoundationHolding = formatFoundationHolding;
